<template>
  <div class="contacts-page">
    <div class="max-width">
      <div class="subs">
        <router-link to="/" class="subs__links">Home</router-link>
        <span>Contacts</span>
      </div>

      <div class="contacts-page__grid">
        <div class="contacts-page__about">
          <div class="section__head section__head_middle">
            <div class="section__subheading section__subheading_themes fadeIn">Reach Out</div>
            <h1 class="section__title">In One Click</h1>
            <div class="section__text">Whether it’s customization guidance, technical support, or feature questions, we’re here to help anytime.</div>
          </div>
        </div>

        <div class="contacts-page__content fadeIn">
          <div class="contacts-page__ill-1"><img src="@/assets/imgs/left-ill.svg" alt=""></div>
          <div class="contacts-page__ill-2"><img src="@/assets/imgs/right-ill.svg" alt=""></div>
          <div class="contacts-page__form">
            <form class="sh-form form-contacts">
              <input type="hidden" name="TYPE_FORM" value="contact">
              <input type="hidden" name="Theme" value="None">
              <input type="hidden" name="PORTFOLIO" value="Almost Perfect">
              <div class="sh-form__grid">
                <div class="sh-form__field">
                  <label>Name<span>*</span></label>
                  <input
                      class="input-text input-name"
                      type="text"
                      name="Name"
                      placeholder="Your Name"
                      required
                  />
                </div>
                <div class="sh-form__field">
                  <label>E-mail<span>*</span></label>
                  <input
                      class="input-text input-email"
                      type="email"
                      name="Email"
                      placeholder="Enter your e-mail"
                      required
                  />
                </div>
                <div class="sh-form__field sh-form__field_full">
                  <label>Message</label>
                  <small>Please provide details and, if necessary.</small>
                  <textarea
                      class="input-text input-message"
                      name="Message"
                      placeholder="Your Message"
                      required
                  ></textarea>
                </div>
              </div>

              <div class="sh-form__checkboxes">
                <div class="sh-form-checkbox">
                  <input type="checkbox" name="AGREEMENT" class="checkbox-terms" id="checkbox-terms">
                  <label for="checkbox-terms">I agree to the <router-link to="/terms" target="_blank">Terms</router-link> & <router-link to="/privacy" target="_blank">Privacy Policy</router-link></label>
                </div>
                <div class="sh-form-checkbox">
                  <input type="checkbox" name="SUBSCRIBE" id="checkbox-newsletter">
                  <label for="checkbox-newsletter">Keep me updated with theme news and tips</label>
                </div>
              </div>

              <button class="sh-form__submit sh-form__submit_full" type="submit">
              <span class="button button_dark">
                Submit Request
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.59844 4.2002L11.3984 9.0002L6.59844 13.8002" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
                <div class="sh-form-loader"></div>
              </span>
              </button>

              <p class="sh-from-message"></p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.contacts-page {
  max-width: 772px;
  width:100%;
  margin:0 auto;

  &__about {
    @include md {
      padding: 0;
      text-align: center;
    }

    .section__head {
      margin: 0;
    }
  }

  &__content {
    position:relative;
  }

  &__ill-1 {
    position:absolute;
    right:100%;
    bottom:100%;
    width:32px;
    height:24px;

    @include md {
      display:none;
    }
  }

  &__ill-2 {
    position:absolute;
    left:100%;
    top:100%;
    width:31px;
    height:29px;

    @include md {
      display:none;
    }
  }

  &__form {
    margin-top:112px;
    background: #fff;
    padding: 2.5rem;
    width: 100%;
    border-radius: 24px;

    @include md {
      margin-top:3rem;
      padding:1.5rem;
      border-radius:16px;
    }
  }
}
</style>

<script setup>
import { onMounted } from 'vue'
import JustValidate from 'just-validate'

import { useHead } from '@vueuse/head'

useHead({
  title: 'Contacts – Almost Perfect Studio',
  meta: [
    { name: 'description', content: 'Get in touch with Almost Perfect Studio via our contact form. We assist with bug fixes, theme customizations, and questions regarding themes.' }
  ]
})

onMounted(() => {
  const form = document.querySelector('.form-contacts')

  if (form) {
    const validation = new JustValidate(form)

    validation
        .addField('.checkbox-terms', [
          {
            rule: 'required',
            value: true,
            errorMessage: 'Please select agrees'
          }
        ])
        .addField('.input-name', [
          {
            rule: 'minLength',
            value: 3
          },
          {
            rule: 'maxLength',
            value: 30
          },
          {
            rule: 'required',
            value: true,
            errorMessage: 'Please enter your first name'
          }
        ])
        .addField('.input-email', [
          {
            rule: 'required',
            value: true,
            errorMessage: 'Please enter your email'
          },
          {
            rule: 'email',
            value: true
          }
        ])
        .addField('.input-message', [
          {
            rule: 'required',
            value: true,
            errorMessage: 'Please enter your message'
          }
        ])
        .onSuccess((event) => {
          const formData = new FormData(event.target)
          const xhr = new XMLHttpRequest()

          form.classList.add('loading')

          const messageEl = document.querySelector('.sh-from-message');
          messageEl.classList.remove('sh-from-message_success', 'sh-from-message_error');
          messageEl.textContent = '';

          xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
              if (xhr.status === 200) {
                messageEl.textContent = 'Thank you for your submission! We will contact you shortly.'
                messageEl.classList.add('sh-from-message_success')
                event.target.reset()
              } else {
                messageEl.textContent = 'Something went wrong.'
                messageEl.classList.add('sh-from-message_error')
              }
              form.classList.remove('loading')
            }
          }

          xhr.open('POST', 'https://creativecommercelabs.com/zendesk/subscribe.php', true)
          xhr.send(formData)
        })
  }
})
</script>
